import { Dispatch, SetStateAction } from "react";

import useShipmentFilters from "hooks/filters/useShipmentFilters";
import FilterAccordions from "components/organisms/Filter/components/FilterAccordions";

interface EditFilterProps {
  currentFilters: Record<string, any> | undefined;
  setFilters: Dispatch<SetStateAction<Record<string, any> | undefined>> | Function;
}

function EditShipmentFilter({ currentFilters, setFilters }: EditFilterProps) {
  const { config } = useShipmentFilters({ type: "shipper" });

  const eventContext = "Edit Shipment Preset";

  if (!currentFilters) return null;
  return (
    <FilterAccordions config={config} currentFilters={currentFilters} setFilters={setFilters} eventContext={eventContext} />
  );
}

export default EditShipmentFilter;
